import { render, staticRenderFns } from "./sso-google.vue?vue&type=template&id=3525b55c&scoped=true&"
import script from "./sso-google.ts?vue&type=script&lang=ts&"
export * from "./sso-google.ts?vue&type=script&lang=ts&"
import style0 from "./sso-google.scss?vue&type=style&index=0&id=3525b55c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3525b55c",
  null
  
)

export default component.exports